interface WindowsWebView {
  postMessage(message: string): void;
}

interface WindowsWindow extends Window {
  chrome?: {
    webview?: WindowsWebView;
  };
}

export function nativeWindow(): WindowsWindow {
  return window as WindowsWindow;
}

export function webview(): WindowsWebView | undefined {
  return nativeWindow().chrome?.webview;
}

export function isHostedInWin(): boolean {
  return !!webview();
}
